import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';
import {buildAuctionHistorySidebarAction} from '@dms/vehicle-auction';

import {buildArray} from 'shared/web';

interface VehicleActivityPanelProps {
  vehicleId: string;
}

export function VehicleActivityPanel(props: VehicleActivityPanelProps) {
  const actions = buildArray<ActivitySidebarAction>()
    .whenFeatureEnabled(
      featureFlags.CUSTOM_NOTICES,
      buildCustomNoticesSidebarAction({
        resourceId: EntityResourceIds.vehicle,
        recordId: props.vehicleId,
      })
    )
    .whenFeatureEnabled(
      featureFlags.AUCTIONS,
      buildAuctionHistorySidebarAction({vehicleId: props.vehicleId})
    );

  return <ActivitySidebarV2 actions={actions} />;
}
